import { render, staticRenderFns } from "./AddFollowUpModal.vue?vue&type=template&id=21033966&"
import script from "./AddFollowUpModal.vue?vue&type=script&lang=js&"
export * from "./AddFollowUpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports